export function formatUserRole(
  role: string | null | undefined,
  emptyLabel = 'No role'
): string {
  if (!role) {
    return emptyLabel;
  }

  return role
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function formatMemberSinceDate(createdAt: string): string {
  const date = new Date(createdAt);
  const month = date.toLocaleDateString('en-US', { month: 'short' });
  const day = date.getDate();
  const year = date.getFullYear();

  return `${month} ${day}, ${year}`;
}
